import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
import moment from 'moment';
import { EventApi } from '@fullcalendar/react';

interface Props {
	event: EventApi;
	handleEventMouseLeave: (e: React.MouseEvent<HTMLDivElement>) => void;
	handleEventMouseOver: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const CalendarMonthViewEvent: React.FC<Props> = ({
	event,
	handleEventMouseLeave,
	handleEventMouseOver,
}) => {
	const { t } = useTranslation();

	return (
		<div
			className='custom-month-event'
			style={{ backgroundColor: event.backgroundColor }}
			onMouseLeave={handleEventMouseLeave}
			onMouseEnter={handleEventMouseOver}
			data-event-id={event.id}>
			<div>
				{`${moment(event.start).format('HH:mm')} - ${moment(event.end).format(
					'HH:mm',
				)} ${event.title}`}
			</div>
		</div>
	);
};

export default CalendarMonthViewEvent;
